import React from 'react'
import {Icon} from '@chakra-ui/react'
const AddIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="add-icon" {...props}>
            <rect x="3" y="18.5" width="34" height="3" fill="currentColor" />
            <rect x="18.542" y="3.33333" width="2.93" height="33.3333" fill="currentColor" />
        </Icon>
    )
}

export default AddIcon
